import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';
import { useCorrectIconsInOfferListRowExperiment } from 'src/hooks/experiments';

import {
  IconChevronDown,
  IconChevronUp,
  IconMenuKebab,
} from '@prisjakt/ui/icon';
import { MediumUp, MobileOnly } from 'src/ui/block';

import { IconProps } from '@prisjakt/ui/icon/types';

import * as S from './styles';

interface IExpandButton {
  expanded?: boolean;
  onClick?: () => void;
  title?: string;
}

export const ExpandButton: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IExpandButton>
>> = ({ expanded = false, onClick, title }) => {
  const { isFeatured, showExpandButton } = usePriceRowContext();
  const useCorrectIconsInOfferListRow = useCorrectIconsInOfferListRowExperiment();

  const getColor = () => (isFeatured ? 'maybeBlue700' : 'base500');

  const getIcon = (iconProps: IconProps) => {
    if (!useCorrectIconsInOfferListRow) return <IconMenuKebab {...iconProps} />;
    if (expanded) return <IconChevronUp {...iconProps} />;
    return <IconChevronDown {...iconProps} />;
  };

  return (
    <S.ExpandButton
      type="button"
      aria-label={title}
      onClick={onClick}
      data-test="ExpandButton"
      $expanded={expanded}
      $hidden={!showExpandButton}
    >
      <MobileOnly>{getIcon({ color: getColor(), size: 24 })}</MobileOnly>
      <MediumUp>{getIcon({ color: 'maybeBlue700', size: 24 })}</MediumUp>
    </S.ExpandButton>
  );
};
